import { SeoMetaData } from '@cms-max/cms-browser-api-client'
import { Component } from '@cms-max/medicare-api-sdk'

export const authRepSeoMetaData: SeoMetaData[] = [
  {
    path: '/account-settings/auth-rep',
    seo: {
      en: {
        title: 'Authorized representatives | Medicare',
        description: 'You can allow someone you trust to talk to us about your Medicare if you aren’t able to yourself. Learn more about authorized representatives.'
      },
      es: {
        title: 'Representantes autorizados | Medicare',
        description: 'Puede permitir que alguien de su confianza hable con nosotros sobre su Medicare si no puede hacerlo usted mismo. Obtenga más información sobre los representantes autorizados.'
      }
    }
  },
  {
    path: '/account-settings/auth-rep/new',
    seo: {
      en: {
        title: 'Add authorized representative information | Medicare',
        description: 'Medicare will only disclose information based on what you choose in this form.'
      },
      es: {
        title: 'Agregar información de representante autorizado | Medicare',
        description: 'Medicare sólo divulgará información basado en lo que elija en este formulario.'
      }
    }
  },
  {
    path: /\/account-settings\/auth-rep\/edit\/[^/]*$/,
    seo: {
      en: {
        // TODO: This needs to be unique for 508 compliance
        title: 'Edit authorized representative information | Medicare',
        description: 'Medicare will only disclose information based on what you choose in this form.'
      },
      es: {
        title: 'Editar la información del representante autorizado | Medicare',
        description: 'Medicare sólo divulgará información basado en lo que elija en este formulario.'
      }
    }
  }
].map((seoData) => ({ ...seoData, component: Component.AuthorizedRepresentative }))
